import {Stack, Typography} from "@mui/material";
import mobileClasses from "@/pages/Deposit/Variety/mobile.module.css";
import {useMemo, useState} from "react";
import {useSelector} from "react-redux";


interface Props {
  onSelect: (variety: any) => void
  varietyOperate?: string
}

const VarietySelect = (props: Props) => {
  const { onSelect, varietyOperate } = props;
  const [selected, setSelected] = useState(null);
  const {user,homeInfo} = useSelector((state) => state.user);
  // const userHomeReq = useUserVariteies()

  const _accountList = useMemo(() => {
    if (!homeInfo) {
      return [];
    }
    if (!homeInfo?.assetUser.accountList) {
      return []
    }
    return homeInfo?.assetUser.accountList.filter(_ => {
      return !_.shortName.includes('USDⓈ');
    })
  }, [homeInfo?.assetUser.accountList, varietyOperate])

  return (
    <Stack  gap="12px" className={mobileClasses.varieties}>
      {_accountList.map((variety) => {
        return (
          <Stack
            key={variety.varietyCode}
            gap="8px"
            onClick={() => {
              setSelected(variety)
              onSelect && onSelect(variety)
            }}
            sx={theme => {
              return {
                backgroundColor: (selected && variety.varietyCode == selected.varietyCode) ? theme.palette.background.other1 : theme.palette.background.default,
                '& img': {
                  width: theme.typography.pxToRem(28),
                  height: theme.typography.pxToRem(28),
                }
              }
            }}
            direction="row" alignItems="center" className={mobileClasses.row}>
            <img src={`/images/coin/${variety.varietyCode.toLowerCase()}.svg`} alt={`${variety.shortName}.png`} />
            <Stack >
              <Typography sx={(theme) => ({ fontSize: theme.typography.pxToRem(15) })}>{variety.varietyCode.toUpperCase()}</Typography>
              <Typography sx={(theme) => ({
                fontSize: theme.typography.pxToRem(12),
                color: theme.palette.text.tertiary,
              })}>{variety.shortName}</Typography>
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}

export default VarietySelect;